import apiClient from '../../../api-client';

export class CommentService {
  public async addProjectComment(
    companyId: number,
    projectId: number,
    phaseId: number,
    taskId: number,
    comment: any
  ) {
    try {
      const response = await apiClient.post(
        `${process.env.GATSBY_SSO_BACKEND_API_URL}/backoffice/${companyId}/projects/${projectId}/phase/${phaseId}/task/${taskId}/comments`,
        { ...comment }
      );

      return response.data;
    } catch (error: any) {
      console.log(error);
      throw new Error(
        `error generating url: ${error.response?.statusText || error.message}`
      );
    }
  }
}
